var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriverAction1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3594 13C16.8824 13 21.3594 7 21.3594 7C21.3594 7 16.8824 1 11.3594 1C5.83638 1 1.35938 7 1.35938 7C1.35938 7 5.83638 13 11.3594 13Z",
    stroke: "#9C4900",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3594 9.5C12.0224 9.5 12.6583 9.23661 13.1271 8.76777C13.596 8.29893 13.8594 7.66304 13.8594 7C13.8594 6.33696 13.596 5.70107 13.1271 5.23223C12.6583 4.76339 12.0224 4.5 11.3594 4.5C10.6963 4.5 10.0604 4.76339 9.59161 5.23223C9.12277 5.70107 8.85938 6.33696 8.85938 7C8.85938 7.66304 9.12277 8.29893 9.59161 8.76777C10.0604 9.23661 10.6963 9.5 11.3594 9.5Z",
    stroke: "#9C4900",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverAction1);
export default __webpack_public_path__ + "static/media/Driver_action1.e0007aebdb2a38accd3ee05a9623c51d.svg";
export { ForwardRef as ReactComponent };